import * as React from "react";
import styles from "./styles.scss";
import { useAiChatAssistantHooks } from "app/components/ai-chat-assistant/hooks/use-ai-chat-assistant-hooks";
import { Link } from "react-router-dom";
import { routeConstants } from "app/routes/route-constants";
import { useEffect, useRef } from "react";
import { ChatInput } from "app/components/ai-chat-assistant/components/chat-input";
import { ChatMessages } from "app/components/ai-chat-assistant/components/chat-messages";
import { ChatFooter } from "app/components/ai-chat-assistant/components/chat-footer";
import { ElementLoader } from "ui/common/element-loader/element-loader";

const useChatActivation = (
  inputText: string,
  isChatActive?: boolean,
  setChatAssistantActive?: () => void
) => {
  const prevInputTextRef = useRef("");

  useEffect(() => {
    const prevInputText = prevInputTextRef.current;
    const hasInput = inputText?.trim?.().length > 0;
    const isChanged = hasInput && prevInputText !== inputText;
    if (isChanged && !isChatActive) {
      setChatAssistantActive?.();
    }

    prevInputTextRef.current = inputText;
  }, [inputText, isChatActive, setChatAssistantActive]);
};

export const AiChatAssistant = ({
  setChatAssistantActive,
  isChatActive
}: {
  setChatAssistantActive?: () => void;
  isChatActive?: boolean;
}) => {
  const {
    caseDraftCreation,
    running,
    messages,
    inputText,
    setInputText,
    send,
    endRef,
    clearChat,
    abortChat,
    translation,
    registerCase,
    canActOnDraft,
    onKeyDown,
    createDraft
  } = useAiChatAssistantHooks();

  const hasChatMessages = messages?.length > 0;
  useChatActivation(inputText, isChatActive, setChatAssistantActive);

  if (!caseDraftCreation) {
    return null;
  }

  return (
    <div className={styles.chatShell}>
      {hasChatMessages && (
        <ChatMessages
          messages={messages}
          running={running}
          endRef={endRef}
          translation={translation}
        />
      )}
      {createDraft &&  <div className={styles.elementLoader}>
        <ElementLoader />
      </div>}
      <ChatInput
        inputText={inputText}
        setInputText={setInputText}
        send={send}
        running={running}
        placeholder={translation.textAiChatAssistantPlaceholder}
        abortChat={abortChat}
        onKeyDown={onKeyDown}
      />
      {!hasChatMessages ? (
        <div>
          <Link
            to={routeConstants.selectCaseType}
            className={`btn btn-call-to-action ${styles.btnRegisterNewCase}`}
          >
            {translation.textRegisterNewCase}
          </Link>
        </div>
      ) : null}
      
      {hasChatMessages && (
        <ChatFooter
          clearChat={clearChat}
          registerCase={registerCase}
          canActOnDraft={canActOnDraft}
          textRegisterCase={translation.textRegisterCase}
          textClearChat={translation.textClearChat}
        />
      )}
     
    </div>
  );
};
